module.exports =  {
  hotel: {
    BOOKING_NOW: '立即預訂',
    Book_Hotel: '預訂酒店',
    Select_your_destination: '請選擇目的地',
    Please_enter_your_destination: '請輸入目的地/酒店',
    Booked_up: '已訂完',
    Hotel_description: '酒店介紹',
    Check_in_date: '入住日期',
    Check_out_date: '退房日期',
    Sold_out: '售完',
    Non_refundable: '不可取消',
    reserve: '訂',
    Pay_Online: '在線付',
    Only_rooms_left_before: '還剩',
    Only_rooms_left_after: '間',
    Cancellation_Policy: '取消政策',
    See_all_prices_before: '查看全部',
    See_all_prices_after: '個價格',
    Estimated_time_of_arrival: '預計到店',
    make_your_schedule_well_planned: '為當地時間，選定後請合理安排出行。',
    Hotel_Not_Found: '未找到所選條件的酒店',
    Please_change_your_search: '請修改條件重新查詢',
    Submit_an_application: '提交申請',
    Hotel_Confirmation: '酒店確認',
    Many_Night_Stay_before: '入住',
    Many_Night_Stay_after: '晚',
    Hotel_Booking_Number: '酒店預約號',
    Online_Payment: '在線支付',
    The_guest_Room_before: '入住人',
    The_guest_Room_after: '】',
    Contact_number: '聯繫號碼',
    Bring_all_valid_IDs: '入住時請攜帶所有入住人的有效身份證件。',
    Hotels_Found_before: '搜索到',
    Hotels_Found_after: '家酒店',
    Hotels_Presented_before: '當前顯示',
    Hotels_Presented_center: '家酒店(共',
    Hotels_Presented_after: '家)',
    Please_change_the_dates: '沒有查詢到所選日期的房型，請重新選擇住宿日期。',
    Login: '预订酒店需要登录app',
    Nights_in_total_before: '共',
    Nights_in_total_after: '晚',
    Location: '酒店位置',
    Pictures: '酒店圖片',
    Description: '酒店介紹',
    Policy: '酒店政策',
    Check_in_and_check_out_time: '入離時間',
    Check_in_and_Check_out_before: '入住時間：',
    Check_in_and_Check_out_center: '以后  離店時間：',
    Check_in_and_Check_out_after: '以前',
    Check_in_time: '入住時間',
    Check_out_time: '離店時間',
    Hotel_Information: '基本信息',
    Opening_Date: '開業時間',
    Renovation_Date: '裝修時間',
    Facility_Service: '設施服務',
    Payment_methods: '酒店接受的支付方式',
    Hotel_Address: '酒店地址',
    Pay_online: '在線支付',
    Pay_offline: '線下支付',
    Night_stay_before: '入住',
    Night_stay_after: '晚,',
    Rooms_total_before: '間共',
    Rooms_total_after: '',
    Guest_name_must_be_provided: '入住人姓名必須填寫完整',
    Please_fill_in_your_contact_number: '請輸入聯繫號碼',
    Select_estimated_time_of_arrival: '請選擇預計到店時間',
    Number_of_Rooms: '房間數量',
    Maximum_guests_per_room_before: '每間最多入住',
    Maximum_guests_per_room_after: '人',
    Many_Rooms: '間',
    Service_Fee_Included: '(含稅和服務費)',
    Last_Name: '姓氏拼音',
    First_Name: '名字拼音',
    Room: '房間',
    Additional_Tax: '另付稅費',
    Please_inform_the_hotel: '若超過登記的預計到店時間，請務必聯絡住宿酒店。',
    Please_inform_the_hotel_first: '沒有提前與酒店聯絡，導致超過最遲入住時間時，房間或晚餐安排會有影響，請注意提前確認。',
    Booking_Cancellation: '取消訂單',
    Reason_of_Cancellation: '取消原因',
    Incorrect_Information_Filled: '信息填錯',
    Itinerary_Changed: '行程改變',
    Lower_price_on_other_APP: '其他APP更便宜',
    Low_quality_hotel: '酒店质量差',
    Book_at_a_lower_price: '前台預訂更實惠',
    Other: '其他',
    Please_write_your_reason: '請填寫原因',
    After_cancellation_done: '取消成功後，款項將會在3個工作日退回到您的原支付方。',
    How_to_fill_in_the_guest_name: '入住人填寫說明',
    It_should_be_exactly_the_same: '預訂酒店必須填寫入住人的姓名，以英文字母填寫。需與入住時所持證件完全一致。',
    How_to_fill_in_a_Chinese_name: '中文姓名填寫方法：',
    How_to_fill_in_a_English_name: '英文姓名填寫方法：',
    For_example: '例如：“韓梅梅”，姓填寫“Han”，名填寫“Meimei”',
    No_specical_characters: '英文姓名中不能包含數字或特殊符號',
    Name_rule_first: '② 姓在前，名在後，如有中間名則空一格緊隨名之後。',
    Name_rule_second: ' 例如：Green / Jim Stephanie',
    Details: '明細',
    Pay_now: '立即支付',
    Hotel: '酒店',
    Check_in: '入住：',
    Car: '租車',
    All_bookings: '全部訂單',
    All: '全部',
    the_real_scene: '圖片僅供參考，請以實際入住酒店為準',
    COUPON_TXT: '優惠券',
    SHEET: '張',
    NONE_USE_TEXT: '暫無可用',
    USE_COUPON: '使用優惠券',
    BINDING_COUPON: '綁定新劵',
    DESELECT_COUPON: '取消選擇優惠劵',
    AVAILABLE: '可用',
    NO_COUPON_AVALIABLE: '暫無可用的優惠券',
    UNAVAILABLE: '不可用',
    NOT_ACTIVE: '未生效',
    COUPON_TO_BINDING: '綁定優惠券',
    WRITE_PREFERETIAL_CODE: '請輸入優惠碼',
    BINDING_USE: '綁定並使用',
    HAS_DEDUCTED_BEFORE: '已减',
    HAS_DEDUCTED_AFTER: '',
    PERSON_COUNT: '人',

    NAME_TXT: '姓名',
    HOLDER_NAME: '持卡人姓名',
    EXPIRATION_DATE: '到期日',
    FORMAT_TXT: '格式',
    SECURITY_CODE: '安全碼',
    MASTER_CARD_NAME: 'Master Card',
    JCB_CARD_NAME: 'JCB',
    DIGITS_ON_BACK_OF_CARD: '卡片背後的3比特數位。',
    AMERICAN_EXPRESS_NAME: 'American Express',
    FOUR_CAR_NUM_TIPS: '卡片正面的4位數',
    ENTER_COMPLETE_CARD_NUM: '請輸入完整卡號',
    PLEASE_ENTER_HOLDER_NAME: '請輸入持卡人姓名',
    ENTER_SECURITY_CODE: '請輸入安全碼',
    ENTER_EXPIRATION_DATE: '請輸入到期日',
    ROOM_DETAILS: '客房詳情',
    CONDITION_CANCEL: '條件取消',
    CHOOSE_PAYMENT_METHOD: '選擇支付方式',
    ORDER_TOTAL_LUMP: '訂單總額',
    CREDIT_CARD_NUM: '借記卡/信用卡號',
    MAINLAND_CARD_ONLY: '僅限中國大陸以外地區發行的銀行卡',
    SHUT_DOWN: '關閉',

    SELECT_COUNTRY_CODE: '選擇國家或地區',
    HOT_COUNTRY_OR_AREA: '熱門國家/地區',
    EVAL_LIST_NO_DATA: '暫無數據',


    // 酒店搜索改版新增翻译
    PREFIX_ROOMS: '',
    SUFFIX_ROOM: '間',
    SUFFIX_ROOMS: '間',
    PREFIX_ADULTS: '',
    SUFFIX_ADULT: '成人',
    SUFFIX_ADULTS: '成人',
    PREFIX_CHILDREN: '',
    SUFFIX_CHILD: '兒童',
    SUFFIX_CHILDREN: '兒童',
    ROOM: '客房',
    AGE: '歲',
    AGES: '歲',
    SELECT_ROOMS_TIPS: '請提供所有入住兒童的年齡，以便我們為您找到最合適的房型、床型。',
    CHECK_IN_DETAIL: '入住詳情',
    CHILD_AGE: '兒童年齡',
    FILTER_CONDITION: '您的篩選條件是：',
    NO_MATCH_TIPS: '以下客房不符合“間數”、“人數”篩選條件',
    ROOM_COUNT: '間數',
    GUESTS: '人數',
    NO_MATCH_HOTEL: '以下為不符合篩選條件的酒店',
    TAXES_INCL: '含稅總價',
    BOOK_TIMEOUT_TIPS: '頁面超時，請返回酒店詳情頁刷新預訂。價格和空房情況可能在這段時間有變動。',
    LIST: '列表',
    RENT_CAR_BOOK: '預訂',
    HOTEL_STR: '詳情',
    SETTLEMENT_DETAIL: '住客詳情',
    CONTACT_NAME: '聯繫人姓名',
    COUNTRY_CODE: '國家/地區代碼',
    PHONE_NUMBER: '手機號碼',
    TRAVEL_PHONE_NUMBER: '請輸入聯繫人姓名',
    PLEASE_SELECT_AREA_CODE: '請選擇國家/地區代碼',

    Search: '搜索',
    COST_DESCRIPTION: '費用明細',
    TOTAL: '合計',
    SEE_ORDER_INFO_TO: '支付',
    KONW: '知道了',
    BOOKING_INFORMATION: '預訂須知',
    Book_Now: '立即支付',
    MAP: '地圖',
    CONTACT_INFORMATION: '聯繫方式',
    LOADING: '加載中...',
    SORT_FILTER: '排序/篩選',
    SCREENING: '篩選',
    SEQUENCE: '排序',
    PHONE_ASK: '電話諮詢',
    ABOVE: '起',
    SUBMINT_ORDER: '提交訂單',
    OK: '確定',
    Order_detail: '訂單明細',
    BOOKING_INFO: '訂單信息',
    PAYMENT_AMOUNT: '訂單金額',
    Order_time: '下單時間',
    ORDER_NUMBERS: '訂單號',
    PAY_TYPE: '支付方式',
    BALANCE: '賬戶餘額',
    CURRENT_BALANCE_BEGIN: '當前餘額',
    OVERPLUS_BALANCE_BEGIN: '結餘',
    OTHER_PAYMENT: '其他支付方式',
    Unionpay: 'UnionPay',
    Wechatpay: '微信支付',
    Alipay: 'Alipay',
    AGREE_SERVICE_AGREEMENT_BEFORE: '點擊“立即支付”即表示您同意百高',
    AGREE_SERVICE_AGREEMENT_AFTER: '',
    SERVICE_AGREEMENT: '《服務協議》',
    PAYMENT_ORDER: '支付訂單',
    Total_pay: '应付总額',
    PAY_SUCCESS: '支付成功',
    CHECK_THE_ORDER: '查看訂單',
    BACK_TO_INDEX: '返回首頁',
    CANCEL: '取消',
    RECOMMED: '推薦',
    PRICE: '價格',
    HIGH: '高',
    LOW: '低',
    RESET: '重置',
    SELECT_TIME: '選擇日期',
    Hotel_guest: '入住人',
    Select: '請選擇',
    Emial_address: '請輸入郵箱地址',
    Booking_explan: '預訂說明',
    VIEW_MORE: '查看更多',
    COLLAPSE: '收起',
    Week: '週',
    Month: '月',
    TOURISM_CHECK_IN_HOTEL: '入住',
    TOURISM_LEAVE_HOTEL: '離店',
    SUBMIT: '提交',
    EMAIL: '郵箱',
    BOOK_FAIL: '預訂不成功',
    BOOK_FAIL_DETAIL: '哎呀... 預訂不成功，請您重新預訂吧！',
    RESET_BOOK: '重新下單',
    ROOM_TYPE_LOADING_TIPS: '正在為您搜索房型價格,請稍等…',
    NEARBY_HOTEL: '附近酒店',
    HOT_CITY: '熱門城市',

    SEARCH_HISTORY: '搜索歷史',
    BREAKFAST_INCLUDE: '含餐',
    BREAKFAST_EXCLUDE: '不含餐',
    DOUBLE_BED: '大床',
    TWIN_BED: '双床',
    FREE_CANCEL: '免費取消',
    MEALS: '餐食',
    EVALUATION: '評價',
    FEATURED_REVIEWS: '評價精選',
    ALL_REVIEWS: '全部評價',
    OVERALL_EVALUATION: '總體評價',
    ANONYMOUS: '匿名',
    EVAL_GENERAL_LIST_1: '差',
    EVAL_GENERAL_LIST_2: '不好',
    EVAL_GENERAL_LIST_3: '一般',
    EVAL_GENERAL_LIST_4: '好',
    EVAL_GENERAL_LIST_5: '很好',
    MAX_IMAGES_WITH_NINE: '最多只能選擇9張圖片',
    GRADE_EVAL: '請選擇總體評價',
    DISTANCE_FILTER: '距離 近→遠',
    EDIT_EVALUATION: '寫評價',
    GO_TO_EVAL: '去評價',
    EVAL_POINTS_AWARD: '最高可獲1000積分(可抵扣10RMB)',
    NEARBY_LIKE_HOTEL: '附近相似酒店',
    DISTANCE_HOTEL: '距離酒店',
    PLEASE_ENTER_COMMENT: '請輸入評價內容',
    AWARD_POINTS_TIPS: '評論有機會贏1000積分 (可抵扣10RMB)',
    NO_SHOW_ANONYMOUS_AVATAR: '匿名評價不會展示您的頭像和暱稱',
    LOCATION: '位置',
    FACILITY: '設施',
    SERVICE: '服務',
    HEALTH: '衛生',
    LANGUAGE_SELECT: '語言選擇',
    LIMIT_COMMENT_TXT: '評價字數必須在 5~2000 內',
    COLLECTED_SUCCEED: '收藏成功！',
    CANCEL_COLLECT: '已取消收藏！',

    PAY_TEXT1:'支付超時，請重新下單',
    PAY_TEXT2:'餘額',
    PAY_TEXT3:'結餘',
    PAY_TEXT4:'未開通',
    PAY_TEXT5:'支付附加手續費',
    PAY_TEXT6:'更多',
    PAY_TEXT7:'點選「立即付款」即表示您同意百高',
    PAY_TEXT8:'服務協定',
    PAY_TEXT9:'房費',
    PAY_TEXT10:'聯絡人',
    PAY_TEXT11:'聯絡電話',
    PAY_TEXT12:'填寫資料',
    PAY_TEXT13:'僅限中國大陸以外地區發行的銀行卡',
    PAY_TEXT14:'國際信用卡支付',
    PAY_TEXT15:'其他付款',
    PAY_TEXT16:'請選擇付款方式',
    PAY_TEXT17:'使用該付款方式將支付CNY',
    PAY_TEXT18:',你確定使用該付款方式嗎?',
    PAY_TEXT19:'支付失敗',
  },
  WX_SHARED: {
    DETAIL_TITLE: '|百高酒店預訂',
    COMMON_TITLE: '搜索酒店|亚洲数万家酒店在线预订',
    SUB_TITLE: '百高為您提供數万家亞洲酒店在線預訂，價格實惠，預訂方便！',
  },
};



// WEBPACK FOOTER //
// ./src/lang/zh_hk.js